<template>
  <transition name="fade">
    <div v-if="show" class="advanced-filters column">
      <!--This is just hidden for now,  don't remove it:-->
      <!-- <DefaultTree
        class="sidebar-margin item-width white-bg-box"
        :heading="industriesNodes.label"
        :filtering="true"
        :nodesState="industriesNodes.options"
        :profileSearchFlag="profileSearchFlag"
        :savedTagsString="savedIndustriesString"
        ref="tree1"
      /> -->

      <div class="input-box">
        <span class="input-box-title">
          Zoek je voor een MKB organisatie?
        </span>
        <!--    <div class="q-pa-md column"> -->
        <div class="column">
          <q-checkbox
            dense
            size="sm"
            v-model="sme"
            val="sm"
            label="Ja"
            class="checkbox"
          />
          <q-checkbox
            dense
            size="sm"
            v-model="notSme"
            val="sm"
            label="Nee"
            class="checkbox"
          />
        </div>
      </div>

      <div class="input-box">
        <span class="input-box-title">
          Indienprocedure
        </span>
        <!--    <div class="q-pa-md column"> -->
        <div class="column">
          <q-checkbox
            dense
            size="sm"
            v-model="before"
            val="sm"
            label="Vooraf"
            class="checkbox"
          />
          <q-checkbox
            dense
            size="sm"
            v-model="after"
            val="sm"
            label="Achteraf"
            class="checkbox"
          />
          <q-checkbox
            dense
            size="sm"
            v-model="beforeAndAfter"
            val="sm"
            label="Vooraf en achteraf"
            class="checkbox"
          />
        </div>
      </div>

      <div class="input-box">
        <span class="input-box-title">
          Scope
        </span>
        <!--    <div class="q-pa-md column"> -->
        <div class="column">
          <q-checkbox
            dense
            size="sm"
            v-model="european"
            val="sm"
            label="Europees"
            class="checkbox"
          />
          <q-checkbox
            dense
            size="sm"
            v-model="national"
            val="sm"
            label="Nationaal"
            class="checkbox"
          />
          <q-checkbox
            dense
            size="sm"
            v-model="regional"
            val="sm"
            label="Regionaal"
            class="checkbox"
          />
          <!-- <q-checkbox
            dense
            size="sm"
            v-model="local"
            val="sm"
            label="Local"
            @click="updateLocal(local)"
            class="checkbox"
          /> -->
        </div>
      </div>
      <div class="button-area">
        <q-btn
          label="Verberg overige filters"
          class="hide-button"
          @click="hideAdvanced()"
        />
      </div>
    </div>
    <div v-else class="button-show">
      <q-btn
        label="Toon overige filters"
        @click="showAdvanced()"
        class="show-btn"
      >     
      </q-btn>
    </div>
  </transition>
</template>

<script>
import { ref, computed } from 'vue';
import store from '../../store/index';
import FiltersService from '../../services/filters.service';
import SchemeUtils from '../../utils/schemes';
//This is just hidden for now,  don't remove it:
// import DefaultTree from '../search-components/DefaultTree.vue';
export default {
  components: {
    // This is just hidden for now,  don't remove it:
    // DefaultTree,
  },
  setup() {
    // const sme = ref(false);
    // const notSme = ref(false);
    // const before = ref(false);
    // const after = ref(false);
    // const beforeAndAfter = ref(false);
    // const european = ref(false);
    // const regional = ref(false);
    // const national = ref(false);

    const show = computed({
      get: () => store.state.advancedFilters.showAdvancedFilters,
    });

    const sme = computed({
      get: () => store.state.advancedFilters.sme,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedFilters/updateSme', val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const notSme = computed({
      get: () => store.state.advancedFilters.notSme,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedFilters/updateNotSme', val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const before = computed({
      get: () => store.state.advancedFilters.before,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedFilters/updateTermBefore', val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const after = computed({
      get: () => store.state.advancedFilters.after,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedFilters/updateTermAfter', val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const beforeAndAfter = computed({
      get: () => store.state.advancedFilters.beforeAndAfter,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedFilters/updateTermBoth', val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const european = computed({
      get: () => store.state.advancedFilters.european,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedFilters/updateEuropean', val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const national = computed({
      get: () => store.state.advancedFilters.national,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedFilters/updateNational', val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const regional = computed({
      get: () => store.state.advancedFilters.regional,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedFilters/updateRegional', val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });

    const tree1 = ref(null);

    const showAdvanced = () => {
      FiltersService.getApplicationTerms();
      store.commit('advancedFilters/enableAdvanced');
    };

    const hideAdvanced = () => {
      store.commit('advancedFilters/disableAdvanced');
    };

    const resetValues = async () => {
      // local.value = false;
      store.commit('advancedFilters/updateSme', false);
      store.commit('advancedFilters/updateNotSme', false);
      store.commit('advancedFilters/updateTermBefore', false);
      store.commit('advancedFilters/updateTermAfter', false);
      store.commit('advancedFilters/updateTermBoth', false);
      store.commit('advancedFilters/updateEuropean', false);
      store.commit('advancedFilters/updateRegional', false);
      store.commit('advancedFilters/updateNational', false);
      if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
    };

    //This is just hidden for now,  don't remove it:
    /*
    const favoriteIndustries = computed({
      get: () => store.state.user.favoriteIndustriesIdsArray,
    });
    const refreshTree = () => {
      tree1.value.refreshTree(favoriteIndustries.value);
    };
    const resetAndRefreshTree = () => {
      tree1.value.resetTree();
      tree1.value.refreshTree(favoriteIndustries.value);
    };
    const updateTreeValues = () => {
      tree1.value.updatePairs(tree1.value.ticked);
      tree1.value.updateSelected(tree1.value.ticked);
    };
    const industriesNodes = computed({
      get: () => store.state.advancedSearch.industries,
    });
    const savedIndustriesString = computed({
      get: () => store.state.user.savedIndustriesTags,
    });
    */

    const isSearchPaused = computed({
      get: () => store.state.advancedSearch.applySavedSearchPause,
    });

    return {
      //This is just hidden for now,  don't remove it:
      /*
      updateTreeValues,
      resetAndRefreshTree,
      industriesNodes,
      savedIndustriesString,
      */
      isSearchPaused,
      resetValues,
      sme,
      notSme,
      showAdvanced,
      before,
      show,
      after,
      beforeAndAfter,
      hideAdvanced,
      european,
      // local,
      national,
      regional,
      // updateLocal,
      //This is just hidden for now,  don't remove it:
      //refreshTree,
      //favoriteIndustries,
      tree1,
    };
  },
};
</script>
